import { render } from "./NFTRow.vue?vue&type=template&id=45025b15&scoped=true"
import script from "./NFTRow.vue?vue&type=script&lang=js"
export * from "./NFTRow.vue?vue&type=script&lang=js"

import "./NFTRow.vue?vue&type=style&index=0&id=45025b15&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45025b15"]])

export default __exports__